import axios from 'axios'
import { AuthenticationError, ServerSideError, InvalidCredentialsError } from '@/errors/errors'
import FormId from '@/formId'

export default class FormService {

	_createHeaders(token) {
		return { headers: { Authorization: "Bearer " + token}}
	}

	async submit(token, form) {
		try {
			const response = await axios.post(process.env.VUE_APP_BACKEND_URL + '/api/adequate-form', form, this._createHeaders(token))
			return response.data.form_id
		} catch (error) {
			this._handleError(error)
		}
	}

	async login(username, password) {
		try {
			const response =  await axios.post(process.env.VUE_APP_BACKEND_URL + '/api/login', {username, password})
			return response.data.token
		} catch (error) {
			if (!error.response)
				throw new ServerSideError()

			if (error.response.status == 404 || error.response.status == 500)
				throw new ServerSideError()

			if (error.response.data.message.includes('Invalid'))
				throw new InvalidCredentialsError()
			else
				throw new ServerSideError()
		}
	}

	async get(page, token) {
		try {
			const response = await axios.get(process.env.VUE_APP_BACKEND_URL + '/api/forms?page=' + page, this._createHeaders(token))
			return response.data.data
		} catch(error) {
			this._handleError(error)
			if (error.response.status == 404)
				return []
		}

	}

	async getForm(id, token) {
		try {
			const response = await axios.get(process.env.VUE_APP_BACKEND_URL + '/api/form/' + id, this._createHeaders(token))
			return response.data.data.form
		} catch(error) {
			this._handleError(error)
			if (error.response.status == 404)
				return {}
		}
	}

	async update(id, form, token) {
		try {
			const formWithId = Object.assign(form, {id : FormId.createFromString(id).toObject() })
			await axios.put(process.env.VUE_APP_BACKEND_URL + '/api/form', formWithId, this._createHeaders(token))
		} catch(error) {
			this._handleError(error)
		}
	}

	_handleError(error) {
		if (error.response == undefined)
			throw new ServerSideError()

		if (error.response.status == 500)
			throw new ServerSideError()
		if (error.response.status == 401) {
			throw new AuthenticationError()
		}
	}
}